const breadcrumbsTextHandler = () => {
  const breadcrumbsList = document.querySelectorAll(".breadcrumbs__link");

  if (breadcrumbsList.length < 2) {
    return;
  }

  const firstElementText = breadcrumbsList[0].innerText;
  const secondElementText = breadcrumbsList[1].innerText;
  function changeText() {
    if (document.documentElement.clientWidth <= 670) {
      breadcrumbsList.forEach((el, i) => {
        if (i < 2) {
          el.innerText = "...";
        }
      });
    } else {
      breadcrumbsList[0].innerText = firstElementText;
      breadcrumbsList[1].innerText = secondElementText;
    }
  }

  changeText();
  window.addEventListener("resize", () => {
    changeText();
  });
};

export { breadcrumbsTextHandler };
